import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { MarkNotificationAsReadResult, markNotificationAsRead } from '~/monolith-api';
import { getRecentNotificationsKey } from './useRecentNotifications';

export function useMarkNotificationAsRead(
   options: UseMutationOptions<MarkNotificationAsReadResult, any, string> = {}
) {
   const queryClient = useQueryClient();

   return useMutation<MarkNotificationAsReadResult, any, string>(markNotificationAsRead, {
      onSuccess() {
         queryClient.invalidateQueries(getRecentNotificationsKey());
      },
      ...options,
   });
}
